import * as angular from 'angular';
import * as uirouter from '@uirouter/angularjs';
import { BrandBar as ReactBrandBar } from '@faithlife/brand-bar';
import { IAppSettings, IUserService } from '../services';
import { react2angular } from 'react2angular';
import * as React from 'react';

import '@faithlife/brand-bar/dist/brand-bar.css';

const localizedResources = require('@faithlife/brand-bar/dist/locales/en-US/resources.json');

const ReactBrandBarShim = (props: {
	$location: angular.ILocationService;
	$log: angular.ILogService;
	$state: uirouter.StateService;
	$window: angular.IWindowService;
	appSettings: IAppSettings;
	avatarUrl: string;
	isAuthenticated: boolean;
	userName: string;
	userService: IUserService;
}) =>
	React.createElement(ReactBrandBar, {
		onSignInRequested: () => {
			props.$log.error('Auth Portal bypassed; cannot handle event: onSignInRequested');
		},
		onRegisterRequested: () => {
			props.$log.error('Auth Portal bypassed; cannot handle event: onRegisterRequested');
		},
		onForgotPasswordRequested: () => {
			props.$log.error('Auth Portal bypassed; cannot handle event: onForgotPasswordRequested');
		},
		onSignOutRequested: () => {
			props.$window.location.href = props.appSettings.signOutUri;
		},
		onLogoClicked: props.isAuthenticated
			? () => {
					const assetListState = 'assets';
					const isAssetListState = props.$state.current.name === assetListState;
					props.$state.go(
						'assets',
						{ reload: isAssetListState },
						{ inherit: false, location: !isAssetListState }
					);
			  }
			: null,
		localizedResources,
		usesAuthentication: true,
		isAuthProcessing: false,
		useAuthPortal: true,
		authPortalSignInUrl: props.userService.getOauthSignInUrl(false),
		faithlifeUrl: props.appSettings.faithlifeUrl,
		...props,
	});

export const BrandBar = react2angular(
	ReactBrandBarShim,
	['avatarUrl', 'isAuthenticated', 'userName'],
	['$location', '$log', '$state', '$window', 'appSettings', 'userService']
);
